import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import axiosInstance from '../utils/api';
import { useAuth } from './AuthContext';

const BasketContext = createContext();

export const useBasket = () => useContext(BasketContext);

export const BasketProvider = ({ children }) => {
  const [itemCount, setItemCount] = useState(0);
  const { authState } = useAuth();

  const fetchBasketCount = useCallback(async () => {
    if (!authState || !authState.user) {
      //console.log('[BASKET-CONTEXT] ⚠️ No authState or user, skipping basket count fetch');
      setItemCount(0);
      return;
    }
    //console.log('[BASKET-CONTEXT] 📡 Fetching basket count at:', new Date().toISOString());
    try {
      const response = await axiosInstance.get('/api/baskets/count');
      //console.log('[BASKET-CONTEXT] ✅ Basket count fetched:', response.data.count);
      setItemCount(response.data.count || 0);
    } catch (error) {
      console.error('[BASKET-CONTEXT] ❌ Failed to fetch basket count:', error.message);
      setItemCount(0);
    }
  }, [authState]);

  useEffect(() => {
    //console.log('[BASKET-CONTEXT] 🔄 useEffect triggered, calling fetchBasketCount');
    fetchBasketCount();
  }, [fetchBasketCount]);

  const value = {
    itemCount,
    fetchBasketCount,
  };

  return (
    <BasketContext.Provider value={value}>
      {children}
    </BasketContext.Provider>
  );
};
